/**
 * `ez.a.create_premade_update` — recipe `293`'s fixed update ("create a pre-made update", 11
 * automations). The body was unknown until the sandbox pass ran the recipe for real; monday
 * posts exactly
 *
 *     <item name> <column title> was changed from <old label> to <new label>
 *
 * attributed to the automation's owner (`discovery/automations/sandbox-experiments.md` E6, which
 * closes open question 22). The old/new labels come from the trigger's `node_results`, so this
 * block only makes sense downstream of a status trigger.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { columnRefSchema } from '../values.js';
export const premadeUpdateParams = z.object({ statusColumnId: columnRefSchema });
export const premadeUpdateAction = defineAction({
    id: 'ez.a.create_premade_update',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'create a pre-made update',
    paramsSchema: premadeUpdateParams,
    requiredColumnTypes: ['status'],
    executable: true,
    references: (params) => [{ kind: 'column', id: params.statusColumnId.columnId, invalid: params.statusColumnId.invalid }],
    async execute(context, params) {
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const item = await context.services.getItem(context.itemId);
        if (item === null)
            return { skipped: 'item_deleted' };
        const column = await context.services.getColumn(context.boardId, params.statusColumnId.columnId);
        const labels = labelsOf(column?.settings);
        const previous = labelText(labels, numberOutput(context, 'prevStatusValue'));
        const next = labelText(labels, numberOutput(context, 'columnValue'));
        const title = column?.title ?? 'Status';
        const body = `${item.name} ${title} was changed from ${previous} to ${next}`;
        const update = await context.services.createUpdate({ itemId: context.itemId, body });
        return { updateId: update.id, body };
    },
});
function labelsOf(settings) {
    const labels = settings?.labels;
    if (typeof labels !== 'object' || labels === null)
        return {};
    return Object.fromEntries(Object.entries(labels).map(([k, v]) => [k, String(v)]));
}
const labelText = (labels, index) => index === null ? '' : (labels[String(index)] ?? '');
function numberOutput(context, field) {
    for (const outputs of Object.values(context.nodeResults)) {
        const value = outputs[field];
        if (typeof value === 'number')
            return value;
        if (value === null)
            return null;
    }
    return null;
}
//# sourceMappingURL=ez.a.create-premade-update.js.map